import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1 6.5C1 4.29086 2.79086 2.5 5 2.5H9.42498C10.0733 2.5 10.695 2.75754 11.1535 3.21596L11.9375 4H19C21.2091 4 23 5.79086 23 8V13H1V6.5Z",
      class: "faded"
    }, null, -1),
    _createElementVNode("rect", {
      x: "1",
      y: "6.375",
      width: "22",
      height: "15.125",
      rx: "4",
      class: "primary"
    }, null, -1)
  ])))
}
export default { render: render }